import { Document } from 'jsonapi-typescript';
import { Observable } from 'rxjs';
import { deserializer } from './deserializer';
import { EmailValidation } from '../interfaces/email-validation.interface';

export function deserializeEmailValidation(emailValidation: Document): Observable<EmailValidation> {
	return new Observable<EmailValidation>((observer) => {
		deserializer.deserialize(emailValidation, (err: Error, response: any) => {
			if (err) {
				observer.error(err);
			} else {
				observer.next(response);
				observer.complete();
			}
		});
	});
}
